
import firebase from 'firebase';

 var config = {
    apiKey: "AIzaSyAGGzMS-um1ETO954qIHPV3HrVXqg13EYM",
    authDomain: "oromorevolution-4de10.firebaseapp.com",
    databaseURL: "https://oromorevolution-4de10.firebaseio.com",
    projectId: "oromorevolution-4de10",
    storageBucket: "oromorevolution-4de10.appspot.com",
    messagingSenderId: "965391458998"
  };

  if(!firebase.apps.length){
      firebase.initializeApp(config);
  }

const auth = firebase.auth();
const db = firebase
export {
  auth,
  db
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js